module.exports = __webpack_public_path__ + "img/myUsed.0ba5409f.png";